import { contains, formatDate } from '../components/cdl-react-components/utilities'
import { formatFileLink } from '../components/cdl-react-components/utilities/files'
import { WEBHOST_URL } from '../components/cdl-react-components/utilities/constants'
import { graphqlFetch } from '../components/cdl-react-components/utilities'

const unquote = json => json
    .replace(/\\"([^\"]+)\\":/g, '$1:')    
    .replace(/"([^"]+)":/g, '$1:')

export const sanitizeJsonForLogs = (jsonObj) => 
    unquote(JSON.stringify(jsonObj))        
    
export const logEvent = (events) => {
    graphqlFetch('auth', `
        mutation {
            logEvent(
                events: ${sanitizeJsonForLogs(events)}
                product: "Discovery Digest",
                useSpaces: true
            )
        }`)
        .then(res => {
            if (res.errors)
                console.error('Error logging event', { events, res })
        })
}

export const logError = (error, ...args) => {
    logEvent({ 'Error': sanitizeJsonForLogs(error) })
    console.error(error, args)
}

export const getArticleFeatureImage = (article) => {
    if (article.image)
        return formatFileLink(article.image)
    
    // If there is no image in the article we have to find the default feature image that should be used - rrogers 2019-08-01
    let image = 'default-feature-image.jpg'

    const articleTypes = article.article_type.map(x => x.name)
    const featureArticle = article.featured_article || contains(articleTypes, 'Feature Article')

    if (featureArticle)
        image = 'Feature_Article_Feature_Image.jpg'
    else if (contains(articleTypes, 'Significant Well'))
        image = 'Sig_Well_Colour_Feature_Image.jpg'
    else if (contains(articleTypes, 'E&P Analysis')) {        
        const epType = article.ep_type && article.ep_type.name
        const epImages = {
            'Monthly Spud Analysis': 'EP_Monthly_Spuds_Feature_Image.jpg',
            'Monthly Production Analysis': 'EP_Production_Feature_Image.jpg',
            'Quarterly Land Analysis': 'EP_Land_Sale_Feature_Image.jpg',
            'Quarterly Completions Analysis': 'EP_Completions_Feature_Image.jpg'
        }

        if (epImages[epType])
            image = epImages[epType]
    }
    else if (
        contains(articleTypes, 'Land Sale Alert') ||
        contains(articleTypes, 'Land Sale Review') ||
        contains(articleTypes, 'Land Sale')
    ) {
        image = 'Land_Sale_Feature_Image.jpg'
    }

    return WEBHOST_URL + '/public/CDD/images/default-images/' + image
}

export const getArticleMapImage = (article) => {
    return article.map_image ?
        formatFileLink(article.map_image) : 
        WEBHOST_URL + '/public/CDD/images/default-images/Location_Map_Default_WC.PNG'
}

export const formatResultsItemDate = (item) => {
    if (!item)
        return ''

    let date = ''
    
    if (item.coming_soon && (!item.publication_date || new Date(item.publication_date) > new Date())) {
        date = 
            (<span className="coming-soon">
                Coming {item.publication_date ? formatDate(item.publication_date) : 'Soon'}
             </span>)
    }
    else 
        date = formatDate(item.publication_date)

    return date
}

export const distinctByProp = (arr, prop) => {
    return arr.reduce((acc, item) => {
        return acc.map(x => x[prop]).indexOf(item[prop]) < 0 ?
            [...acc, item] :
            acc
    }, [])
}

export const deleteCookie = (name, domain= '.canadiandiscovery.com') => {
    if (document.cookie.split(';').some(item => item.trim().startsWith(`${name}=`))) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`
    }
}